// The ?ref= value arrives base64-encoded, or plain when support hands the link out by email.
export const decodeRefEmail = (
  rawRef: string | null,
): { email: string; isEncoded: boolean } => {
  if (!rawRef) return { email: '', isEncoded: false }

  try {
    return { email: window.atob(rawRef), isEncoded: true }
  } catch {
    return { email: rawRef, isEncoded: false }
  }
}
